import * as React from 'react';
import {
    ApplicationData,
    AvailableContingentsRequest,
    AvailableContingentsRequestParams, AvailableContingentsResult, SelectedFilters

} from "./Definitions";
import {requestApi} from "./Request/requestApi";
import {FilterForm} from "./Components/FilterForm";

// @ts-ignore
import styles from "./index.css";
import classNames from "classnames";

export const AvailableContingentsClient = (props: ApplicationData) => {
    const [page, setPage] = React.useState<number>(1)
    const cardsPerPage = 9

    const [isFetching, setIsFetching] = React.useState(false);
    const isInitialized = React.useRef(false);
    const $results = React.useRef<HTMLDivElement>(null);

    const startDate = new Date();
    startDate.setDate(startDate.getDate() + 1);

    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 365);

    const [requestParams, setRequestParams] = React.useState<AvailableContingentsRequestParams>({
        applicationDocumentId: props.applicationDocumentId,
        countryId: null,
        topicId: null,
        startDate: null,
        endDate: null,
        withStartDateDeviation: false,
        withEndDateDeviation: false
    });

    const request = React.useRef<AvailableContingentsRequest>(requestApi(props.endpointUri));
    const [response, setResponse] = React.useState<AvailableContingentsResult[]|null>(null);

    const [results, setResults] = React.useState<AvailableContingentsResult[]|null>(null);

    React.useEffect(() => {
        let isActive = true;

        (async () => {
            setIsFetching(true);

            const response =  await request.current(requestParams);

            if (isActive) {
                isInitialized.current = true
                setResponse(response);
                if (response) {
                    setResults(response.slice(0, cardsPerPage))
                }

                setPage(1);
                setIsFetching(false);
            }
        })();

        return () => {

        };
    }, [requestParams])

    const updateFilterForm = (filters: SelectedFilters) => {
        const tmp = {
            applicationDocumentId: props.applicationDocumentId,
            countryId: (filters.countryId && filters.countryId !== "") ? filters.countryId : null,
            topicId: (filters.topicId && filters.topicId !== "") ? filters.topicId : null,
            startDate: (filters.startDate && filters.startDate !== "") ? filters.startDate : null,
            endDate: (filters.endDate && filters.endDate !== "") ? filters.endDate : null,
            withStartDateDeviation: filters.withStartDateDeviation,
            withEndDateDeviation: filters.withEndDateDeviation
        } as AvailableContingentsRequestParams;

        setRequestParams(tmp);
    }

    const updatePage = () => {
        if (response) {
            const tmp = page +1
            setPage(tmp);

            setResults(response.slice(0, (cardsPerPage * tmp)));
        }
    }

    return (
        <div>
            <FilterForm
                countryOptions={props.countryOptions}
                topicOptions={props.topicOptions}
                startDate={requestParams.startDate ?? ''}
                endDate={requestParams.endDate ?? ''}
                teaserText={props.teaserText}
                onChange={updateFilterForm}
            />

            {
                (isInitialized.current && response && results) ?
                    (
                        <div>

                            <div
                                className={classNames(
                                    styles.more,
                                    !isFetching && styles.cardDisabled
                                )}
                            >
                                {
                                    <div>Aktuelle Angebote werden gesucht ...</div>
                                }
                            </div>
                            <div
                                className={classNames(
                                    styles.cardContainer,
                                    isFetching && styles.cardDisabled
                                )}
                                ref={$results}
                            >
                                {
                                    results?.map((result, index) => (
                                        <div
                                            key={result.id}
                                            dangerouslySetInnerHTML={{__html: result.content}}
                                        >
                                        </div>
                                    ))
                                }

                            </div>

                            {
                                (!isFetching && response?.length > 0 && response?.length > cardsPerPage && (cardsPerPage * page) < response?.length) &&
                                    <div
                                        className={styles.more}
                                    >
                                        <div
                                            className="teaserSimple__moreButton"
                                            onClick={updatePage}
                                        >
                                            <span>MEHR ANZEIGEN</span><i className="fa fa-2x fa-plus"></i>
                                        </div>
                                    </div>
                            }
                            {
                                (response?.length === 0) &&
                                    <div
                                        className={styles.more}
                                    >
                                        Keine Ergebnisse gefunden, bitte ändern Sie die Suche...
                                    </div>
                            }

                        </div>
                    ) :
                    (
                        !isInitialized.current
                            ? <div className={styles.more}>Aktuelle Angebote werden gesucht ...</div>
                            : <div className={styles.more}>Es ist ein Fehler aufgetreten.</div>
                    )
            }
        </div>
    );
}
